<script setup>
import PortalAuthShell from '@/Layouts/PortalAuthShell.vue'
</script>

<template>
  <PortalAuthShell portal="host">
    <slot />
  </PortalAuthShell>
</template>
